/**
 * @generated SignedSource<<db91c26e263962bfce3a00f5c28af803>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "STAFFING" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type DefaultTab_tab$data = {
  readonly label: string;
  readonly typeKey: JiraNavigationItemTypeKey;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_tab">;
  readonly " $fragmentType": "DefaultTab_tab";
};
export type DefaultTab_tab$key = {
  readonly " $data"?: DefaultTab_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"DefaultTab_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "DefaultTab_tab",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "label"
      },
      "action": "THROW",
      "path": "label"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "url"
      },
      "action": "THROW",
      "path": "url"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "typeKey"
      },
      "action": "THROW",
      "path": "typeKey"
    },
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_tab"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "9da2b497cf3cffcac56da38a0c7d758a";

export default node;
